import { Check } from 'lucide-react';
import { resolveThemeToken, type MembershipThemeToken } from '../../themeTokens';
import {
  CREATOR_THEME_TOKENS,
  MAX_NAME_LENGTH,
  normalizeName,
  type CreatorDraftPayload,
} from './draftSchema';

type Props = {
  payload: CreatorDraftPayload;
  onChange: (partial: Partial<CreatorDraftPayload>) => void;
};

const StepBasics = ({ payload, onChange }: Props) => {
  const name = String(payload.name ?? '');

  return (
    <div className="creator-step" data-testid="step-basics">
      <header className="creator-step__header">
        <span className="creator-step__index">1</span>
        <div>
          <h2 className="creator-step__title">Basics</h2>
          <p className="creator-step__subtitle">
            Name your membership and pick the card customers will see.
          </p>
        </div>
      </header>

      <label className="creator-field">
        <span className="creator-field__label">
          MEMBERSHIP NAME
          <span className="creator-field__counter">
            {name.length} / {MAX_NAME_LENGTH}
          </span>
        </span>
        <input
          type="text"
          className="creator-field__input"
          placeholder="Gold"
          value={name}
          onChange={(event) => onChange({ name: normalizeName(event.target.value) })}
          data-testid="creator-basics-name"
        />
        <span className="creator-field__hint">
          A short, recognizable name customers will immediately understand.
        </span>
      </label>

      <fieldset className="creator-field">
        <legend className="creator-field__label">CARD THEME</legend>
        <div className="creator-theme-grid">
          {CREATOR_THEME_TOKENS.map((token) => {
            const theme = resolveThemeToken(token);
            const isSelected = payload.cardTheme === token;
            return (
              <button
                key={token}
                type="button"
                className={`creator-theme-swatch creator-theme-swatch--${theme.textMode}${isSelected ? ' creator-theme-swatch--active' : ''}`}
                onClick={() => onChange({ cardTheme: token as MembershipThemeToken })}
                style={{ background: theme.cardBackground }}
                data-testid={`creator-theme-${token}`}
                aria-pressed={isSelected}
              >
                {isSelected ? (
                  <span className="creator-theme-swatch__check" aria-hidden="true">
                    <Check size={14} />
                  </span>
                ) : null}
                <span className="creator-theme-swatch__label">{theme.label.toUpperCase()}</span>
              </button>
            );
          })}
        </div>
      </fieldset>
    </div>
  );
};

export default StepBasics;
